<app-navbar  *ngIf="session.is_logged"></app-navbar>
<router-outlet></router-outlet>